import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from '../router/index.js';
import store from './store'
import ElementUI from 'element-ui'
import Vcode from "vue-puzzle-vcode";
import '../src/zark/stArk.css';
import '../src/zark/colorUi.css';
import 'element-ui/lib/theme-chalk/index.css'
import {
	Message,
	Notification
} from 'element-ui'
import httpClient from '../src/util/request.js';
import echarts from 'echarts'
import moment from "moment"; //时间格式格式化
import VueQuillEditor from 'vue-quill-editor' // 富文本
// require styles
//import 'quill/dist/quill.core.css'
//import 'quill/dist/quill.snow.css'
//import 'quill/dist/quill.bubble.css'
import VueDnD from "awe-dnd";
import _ from 'lodash'

// import NProgress from 'nprogress' // progress bar
// import 'nprogress/nprogress.css' // progress bar style
// 引入一个 路由的方法
// import { getAsyncRoutes } from '@/util/asyncRouter'
moment.locale('zh-cn');
Vue.prototype._ = _
Vue.prototype.$echarts = echarts
Vue.config.productionTip = false
Vue.use(ElementUI);
Vue.use(VueDnD);
Vue.use(Vcode);
Vue.use(VueQuillEditor)
Vue.prototype.$message = Message;
Vue.prototype.$notify = Notification;
Vue.prototype.$http = httpClient.http;
Vue.prototype.$imageUrlPre = httpClient.prefix;
Vue.prototype.$moment = moment; //赋值使用
new Vue({
	router,
	store,
	render: h => h(App)
}).$mount('#app')

router.beforeEach((to, from, next) => {
	if (to.meta.requireAuth) {
		const token = window.localStorage.getItem('token');
		if (token && token.length > 20) {
			return next();
		} else {
			Message.error('登录验证失败，请重新登录！');
			next({
				path: '/login',
				query: {
					redirect: to.fullPath
				} // 将跳转的路由path作为参数，登录成功后跳转到该路由
			});
		}
	} else {
		next();
	}
});